function detectOsFamily(): string {
  if (typeof navigator === 'undefined') {
    return 'other';
  }
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) {
    return 'ios';
  }
  if (/android/.test(ua)) {
    return 'android';
  }
  return 'other';
}

export function buildWebFingerprint(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  const lang = navigator.language || 'unknown';
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown';
  return `${detectOsFamily()}|${lang}|${tz}`;
}
